export function userIsMemberOfClub(user, clubId) {
    const found = user.userRoles[clubId];
    return found !== undefined;
}
